/**
 * @jest-environment jsdom
 */

import '../line-chart';

describe('chart-el element', () => {
  it('Expect <echarts-line /> element is defined', () => {
    expect(customElements.get('echarts-line')).toBeDefined();
  });
});
